import * as React from "react";
import {cx}       from "emotion";

import {CustomerSupportChat} from "@Common/ui-components/customer-support-chat";

import {Notifications} from "@Xpresso/routes/layout/notifications/notifications";

import {BrandedHeader}          from "./branded-header/branded-header";
import {BrandedBackground}      from "./branded-background/branded-background";
import {BrandedProduct}         from "./branded-product/branded-product";
import {BrandedService}         from "./branded-service/branded-service";
import {BrandedFooter}          from "./branded-footer/branded-footer";
import "./branded-login.scss";

export const BrandedLogin = ({routerHistory, themeScheme}) => {
    return (
        <div className={cx("branded-main-dznts4")}>
            <BrandedHeader themeScheme={themeScheme} />
            <Notifications/>
            <BrandedBackground routerHistory={routerHistory} themeScheme={themeScheme} />
            <BrandedProduct themeScheme={themeScheme} />
            <BrandedService themeScheme={themeScheme} />
            <BrandedFooter themeScheme={themeScheme} />
            <CustomerSupportChat/>
        </div>
    )
}

export const modifyWhiteElement = (hex) => {
    const color = parseColor(hex)
    const saturationLimit = 250
    if(color.red < saturationLimit) {
        return false
    }
    if(color.green < saturationLimit) {
        return false
    }
    if(color.blue < saturationLimit) {
        return false
    }

    return true
}

const parseColor = (hex) => {
    const color = parseInt(hex.replace('#', '0x'))
    const red = color & 0xFF
    const green = (color & 0xFF00) >> 8
    const blue = (color & 0xFF0000) >> 16

    return {
        red: red,
        green: green,
        blue: blue
    }
}
